import React from 'react';
import { TypographyType } from 'Typography/types';

export const getChildrenWithProps = (
  children: React.ReactNode,
  typographyProps?: TypographyType,
) => {
  const childrenArray = React.Children.toArray(children);

  const childrenWithProps = childrenArray.map((child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...typographyProps, ...child.props });
    }

    return child;
  });

  return childrenWithProps;
};
